import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import carouselWidgetIcon from "../../assets/images/carousel_widget.svg";

Scrivito.provideEditingConfig("CarouselWidget", {
  title: "Carousel",
  thumbnail: carouselWidgetIcon,
  attributes: localizeAttrList(["images"], "CarouselWidget"),
  properties: ["images"],
  initialContent: {
    showDescription: "no",
  },
});
